import { EntityForm } from 'components/entity-form';
import { PageHeader } from 'components/page-header';
import { ProvideRootResource } from 'components/hydrate-atoms';

/**
 * The new-entity form under its page header.
 * @return {JSX.Element} The page
 */
export function NewEntityPage() {
  return (
    <>
      <PageHeader
        breadcrumbs={[
          ['/entities', 'Entities'],
          ['/entities/new', 'New Entity'],
        ]}
        title="Entity Creation"
        stickyHeader
        actions={null}
      />
      <ProvideRootResource>
        <EntityForm entity={undefined} getEntity={undefined} loading={false} />
      </ProvideRootResource>
    </>
  );
}
